<template>
	<div class="EWarehousList">
		<div class="tit">
			<span>{{Language.LG.SubmitList2[isLanguage]}}</span>
			<div class="wareLog" @click="toRecords()">{{Language.LG.StoRecords[isLanguage]}}</div>
		</div>
		<div class="list">
			<el-checkbox-group v-model="checkList">
			<div class="item" v-for="(item,index) in unOrdersData" :key="index">
				<div>
					<div class="itName">
						<span class="itText">{{Language.LG.WareBoxNo[isLanguage]}}:<span class="it-Cont">{{item.boxNum}}</span></span>
						<span class="itText">{{Language.LG.WareReceNum[isLanguage]}}:<span class="it-Cont">{{item.t_package_no}}</span></span>
						<span class="itText">{{Language.LG.WareStoTime[isLanguage]}}:<span class="it-Cont">{{item.rent_time}}</span></span>
					</div>
					<div class="itTips">
						<span class="itText" v-if="item.box_style == '5'">{{Language.LG.WareBoxSize[isLanguage]}}:<span>{{Language.LG.SmallBox[isLanguage]}}</span></span>
						<span class="itText" v-else-if="item.box_style == '6'">{{Language.LG.WareBoxSize[isLanguage]}}:<span>{{Language.LG.MedBox[isLanguage]}}</span></span>
						<span class="itText" v-else-if="item.box_style == '7'">{{Language.LG.WareBoxSize[isLanguage]}}:<span>{{Language.LG.BigBoxRd[isLanguage]}}</span></span>
						<span class="itText itEm" v-if="item.order_state == '8'">{{Language.LG.WareNotStorage[isLanguage]}}</span>
					</div>
				</div>
				<!-- <checkbox class="itCheckbox" :value="item.order_id" :checked="item.checked"/> -->
				<el-checkbox class="itCheckbox" :label="item.order_id"></el-checkbox>
			</div>
			</el-checkbox-group>
			
			
		</div>
		
		<div class="checkBtn">
			<button class="btn" @click="cancelUnConfirmOrders()">{{Language.LG.Cancel[isLanguage]}}</button>
			<button class="btn" @click="checkboxAll()">{{Language.LG.SelectAll[isLanguage]}}</button>
			<button class="btn" @click="confirmOrders()">{{Language.LG.Submit[isLanguage]}}</button>
		</div>
		
		<!--按钮组-->
		<EConfigBtn :pushBg="'#151c36'" :backUp="backUp" :quit="quit"></EConfigBtn>
	</div>
</template>

<script>
	import EConfigBtn from '../assets/ConfigBtn.vue'
	import { EloginApi } from '../../../../static/CESite40s/js/api.js'
	import { conLog,storage } from '../../../../static/js/utils/utility.js'
	var vm
	export default {
		data() {
			return {
				configStorage:null,
				userInfo:null,
				
				unOrdersData:[],//列表数据
				
				isLanguage:0,
				Language:'',

				checkList:[],//选中
				
				routeType:'',//路由类型
			};
		},
		created(){
			vm = this
			var configStorage = storage.localGetItem('configStorage');
			if(configStorage){
				this.configStorage = configStorage
			}
			var userInfo = storage.localGetItem('userInfo');
			if(userInfo){
				this.userInfo = userInfo
			}
			
			var isLanguage = storage.localGetItem('isLanguage');
			if(isLanguage){
				this.isLanguage = isLanguage
			}
			this.Language = this.$Language
			this.routeType = this.$route.query.type
			conLog('type',this.routeType)
			this.getUnconfirmedOrders()
		},
		components:{
			EConfigBtn,
		},
		methods:{
			//全选
			checkboxAll(){
				var items = vm.unOrdersData
				vm.checkList = []
				for (var i in items) {
					vm.checkList.push(items[i].order_id)
				}
			},
			//取消订单
			async cancelUnConfirmOrders(){
				const _arr = vm.checkList
				if(_arr==''){
					vm.$message({
						message: '请选择需要取消的订单',
						type: 'error',
						duration:1000
					});
					return
				}
				let data = {
					'sender_phone':vm.userInfo.phone_no,//派件人电话
					'orders':_arr,//需要提交的订单数组
				}
				const res = await EloginApi.confirmOrders(data)
				if(res){
					if(res.meta.code == 200){
						conLog('确认取消',res)
						vm.$message({
							message: '取消成功',
							type: 'error',
							duration:1000
						});
						vm.getUnconfirmedOrders()
					}else{
						vm.$message({
							message: res.meta.message,
							type: 'error',
							duration:1000
						});
					}
				}
			},
			//确认提交订单
			async confirmOrders(){
				const _arr = vm.checkList
				if(_arr==''){
					vm.$message({
						message: '请选择需要入库的订单',
						type: 'error',
						duration:1000
					});
					return
				}
				let data = {
					'sender_phone':vm.userInfo.phone_no,//派件人电话
					'orders':_arr,//需要提交的订单数组
				}
				const res = await EloginApi.confirmOrders(data)
				if(res){
					if(res.meta.code == 200){
						conLog('确认提交',res)
						vm.$message({
							message: '提交成功',
							type: 'error',
							duration:1000
						});
						vm.getUnconfirmedOrders()
					}else{
						vm.$message({
							message: res.meta.message,
							type: 'error',
							duration:1000
						});
					}
				}
			},
			//获取入库未确认的订单
			async getUnconfirmedOrders(){
				let data = {
					'cabinet_id':vm.configStorage.deviceId,//设备id
					'sender_phone':vm.userInfo.phone_no,//派件人电话
					'first_row':0,//当前页，从0开始
					'list_rows':9999,//每页数量
				}
				conLog('订单列表',data)
				let res = await EloginApi.getUnconfirmedOrders(data)
				if(res){
					if(res.meta.code == 200){
						conLog('订单列表',res)
						
						for(var i in res.body){
							res.body[i].boxNum = res.body[i].box_id.replace(vm.configStorage.deviceId,"");
						}
						vm.unOrdersData = res.body
					}else{
						vm.$message({
							message: res.meta.message,
							type: 'error',
							duration:1000
						});
					}
				}
			},
			//跳转到入库记录
			toRecords(){
				vm.$router.push({
					path:'/CEsite40s/EStoRecords',
					query:{
						'type': vm.routeType
					}
				})
			},
			//返回上一页
			backUp(){
				if(vm.routeType == '1'){
					vm.$router.push({
						path:'/CEsite40s/ESelectBox',
					})
				}else if(vm.routeType == '2'){
					vm.$router.push({
						path:'/CEsite40s/EScanCode',
					})
				}
			},
			//退出登录
			quit(){
				vm.$router.push({
					path:'/CEsite40s',
				})
			}
		}
	}
</script>

<style lang="less">
.EWarehousList{
	.checkBtn{
		display: flex;
		justify-content: center;
		padding: 0.15rem 0;
		background: #fff;
		border-top: 0.04rem solid #03a9f4;
		position: absolute;
		bottom: 0.8rem;
		left: 0;
		width: 100%;
		.btn{
			background-color: #151c36;
			margin: 0 0.4rem;
			font-size: 0.3rem;
			border-radius: 0.2rem;
			padding: 0.1rem 0.4rem;
		}
	}
	.list{
		background: #fff;
		overflow: auto;
		height: calc(100vh - 2.94rem);
		.item{
			color: #151c36;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0.2rem;
			border-bottom: 0.02rem solid #555;
			.itCheckbox{
				margin-right: 0.2rem;
			}
			.itName{
				font-size: 0.36rem;
				margin-bottom: 0.1rem;
			}
			.itTips{
				font-size: 0.3rem;
				color: #888;
				.itEm{
					background: #009688;
					color: #fff;
					border-radius: 0.1rem;
					padding: 0.05rem 0;
				}
			}
			.itText{
				margin-right: 0.7rem;
				.it-Cont{
					font-style: normal;
					margin-left: 0.3rem;
				}
			}
		}
	}
	.tit{
		position: relative;
		background: #151c36;
		height: 1.2rem;
		line-height: 1.2rem;
		font-size: 0.45rem;
		text-align: center;
		.wareLog{
			font-size: 0.3rem;
			line-height: 1;
			position: absolute;
			right: 0.3rem;
			top: 48%;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/CEsite40s/WarehousList/WarehousList.vue